<template>
<div>
    <div id="cooling" class="wrapper">
        <!-- 内容は以下に記述して下さい。 -->
        <!-- 冷房 -->
        <app-error-list/>
        <app-section>
            <h3 slot="h3">
                <parts-arrow category="冷房">1</parts-arrow>
                <span>冷房方式を入力して下さい。</span>
            </h3>
            <app-box
                :available="true"
                label="冷房方式"
                class="flex_column"
                name="cs_houhou"
                @click="guideTransition"
            >
                <app-radio
                    v-for="value in ['2', '1', '3']"
                    v-model="cs_houhou"
                    :value="value"
                    unit=""
                    :key="'cs_houhou' + value"
                >
                    {{master.cs_houhou[value]}}
                </app-radio>
            </app-box>
        </app-section>

        <!-- 主たる居室-->
        <div v-if="cs_houhou == '2'">
            <app-section>
                <h3 slot="h3">
                    <parts-arrow category="冷房">2</parts-arrow>
                    <span>
                        <parts-arrow class="line">1</parts-arrow>で「居室のみを冷房する」を選択した場合、主たる居室の冷房設備機器の評価方法を入力して下さい。
                    </span>
                </h3>
                <app-box
                    :available="true"
                    label="冷房設備機器の種類"
                    class="flex_column"
                    name="cs_ldk_type"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="value in ['1', '3', '2']"
                        v-model="cs_ldk_type"
                        :value="value"
                        unit=""
                        :key="'cs_ldk_type' + value"
                    >
                        {{master.cs_ldk_type[value]}}
                    </app-radio>
                </app-box>
                <!-- 主たる居室：ルームエアコン-->
                <app-box
                    v-if="cs_ldk_type == '1'"
                    :available="true"
                    label="エネルギー消費効率の入力"
                    class="flex_column uq_subbox_18em"
                    @click="guideTransition"
                    name="cs_ldk_type1_houhou"
                >
                    <app-radio
                    v-for="(name, value) in master.cs_ldk_type1_houhou"
                        v-model="cs_ldk_type1_houhou"
                        :value="value"
                        unit=""
                        :key="'cs_ldk_type1_houhou' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    label="エネルギー消費効率の区分"
                    @click="guideTransition"
                    name="cs_ldk_aircon_koukouritsu"
                    :available="true"
                    v-if="cs_ldk_type1_houhou == 2 && cs_ldk_type == '1'"
                >
                    <app-radio
                    v-for="(name, value) in master.cs_ldk_aircon_koukouritsu"
                        v-model="cs_ldk_aircon_koukouritsu"
                        :value="value"
                        unit=""
                        :key="'cs_ldk_aircon_koukouritsu' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    label="小能力時高効率型コンプレッサー"
                    @click="guideTransition"
                    name="cs_ldk_aircon_dualcompressor"
                    :available="true"
                    v-if="cs_ldk_type1_houhou == 2 && cs_ldk_type == '1'"
                >
                    <app-radio
                    v-for="(name, value) in master.cs_ldk_aircon_dualcompressor"
                        v-model="cs_ldk_aircon_dualcompressor"
                        :value="value"
                        unit=""
                        :key="'cs_ldk_aircon_dualcompressor' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>

                <!-- 主たる居室：その他の冷房設備機器-->
                <app-box
                    v-if="cs_ldk_type == '3'"
                    :available="true"
                    label="その他の冷房設備機器の名称"
                    class="flex_column"
                >
                    <app-text
                        label=""
                        unit=""
                        v-model="cs_ldk_other_name"
                        class=""
                        subscript=""
                    />
                </app-box>
            </app-section>

            

            <!-- その他の居室 -->
            <app-section v-if="isSonotanokyoshitu && cs_houhou == 2">
                <h3 slot="h3">
                    <parts-arrow category="冷房">3</parts-arrow>
                    <span>
                        <parts-arrow class="line">1</parts-arrow>で「居室のみを冷房する」を選択した場合、その他の居室の冷房設備機器の評価方法を入力して下さい。
                    </span>
                </h3>
                <app-box
                    v-if="bsc_kyoshitsu_kousei == 1 || bsc_sonotakyoshitsu != 2"
                    :available="true"
                    label="冷房設備機器の種類"
                    class="flex_column"
                    name="cs_nldk_type"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="value in ['1', '3', '2']"
                        v-model="cs_nldk_type"
                        :value="value"
                        unit=""
                        :key="'cs_nldk_type' + value"
                    >
                        {{master.cs_nldk_type[value]}}
                    </app-radio>
                </app-box>
                <!-- その他の居室：ルームエアコン-->
                <app-box
                    v-if="cs_nldk_type == '1'"
                    :available="true"
                    label="エネルギー消費効率の入力"
                    class="flex_column uq_subbox_18em"
                    @click="guideTransition"
                    name="cs_nldk_type1_houhou"
                >
                    <app-radio
                    v-for="(name, value) in master.cs_nldk_type1_houhou"
                        v-model="cs_nldk_type1_houhou"
                        :value="value"
                        unit=""
                        :key="'cs_nldk_type1_houhou' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    label="エネルギー消費効率の区分"
                    @click="helpView"
                    name="cs_nldk_aircon_koukouritsu"
                    :available="true"
                    v-if="cs_nldk_type1_houhou == 2 && cs_nldk_type == '1'"
                >
                    <app-radio
                    v-for="(name, value) in master.cs_nldk_aircon_koukouritsu"
                        v-model="cs_nldk_aircon_koukouritsu"
                        :value="value"
                        unit=""
                        :key="'cs_nldk_aircon_koukouritsu' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    label="小能力時高効率型コンプレッサー"
                    @click="guideTransition"
                    name="cs_nldk_aircon_dualcompressor"
                    :available="true"
                    v-if="cs_nldk_type1_houhou == 2 && cs_nldk_type == '1'"
                >
                    <app-radio
                    v-for="(name, value) in master.cs_nldk_aircon_dualcompressor"
                        v-model="cs_nldk_aircon_dualcompressor"
                        :value="value"
                        unit=""
                        :key="'cs_nldk_aircon_dualcompressor' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <!-- その他の居室：その他の冷房設備機器-->
                <app-box
                    v-if="cs_nldk_type == '3'"
                    :available="true"
                    label="その他の冷房設備機器の名称"
                    class="flex_column"
                >
                    <app-text
                        label=""
                        unit=""
                        v-model="cs_nldk_other_name"
                        class=""
                        subscript=""
                    />
                </app-box>
            </app-section>
        </div>
        
        <!-- 住戸全体を冷房する -->
        <div v-if="cs_houhou == '1'">
            <app-section>
                <h3 slot="h3">
                    <parts-arrow category="冷房">4</parts-arrow>
                    <span>
                        <parts-arrow class="line">1</parts-arrow>で「住戸全体を冷房する」を選択した場合、冷房設備機器の評価方法を入力して下さい。
                    </span>
                </h3>
                <app-box
                    :available="true"
                    label="冷房設備機器の種類"
                    class="flex_column"
                    @click="guideTransition"
                    name="cs_type"
                >
                    <app-radio
                        v-for="(name, value) in master.cs_type"
                        v-model="cs_type"
                        :value="value"
                        unit=""
                        :key="'cs_type' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                        v-if="cs_type == '1'"
                    :available="true"
                    label="ダクトが通過する空間"
                    class="flex_column"
                    @click="guideTransition"
                    name="cs_dc_duct_dannnetu"
                >
                    <app-radio
                        v-for="value in ['2', '1']"
                        v-model="cs_dc_duct_dannnetu"
                        :value="value"
                        unit=""
                        :key="'cs_dc_duct_dannnetu' + value"
                    >
                        {{master.cs_dc_duct_dannnetu[value]}}
                    </app-radio>
                </app-box>
                <app-box
                    :available="true"
                    label="VAV方式"
                    class="flex_column"
                    @click="guideTransition"
                    name="cs_dc_vav">
                    <app-radio
                        v-for="(name, value) in master.cs_dc_vav"
                        v-model="cs_dc_vav"
                        :value="value"
                        unit=""
                        :key="'cs_dc_vav' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    :available="true"
                    label="全般換気機能"
                    class="flex_column"
                    @click="guideTransition"
                    name="cs_dc_general_ventilation">
                    <app-radio
                        v-for="value in ['2', '1']"
                        v-model="cs_dc_general_ventilation"
                        :value="value"
                        unit=""
                        :key="'cs_dc_general_ventilation' + value"
                    >
                        {{ master.cs_dc_general_ventilation[value]}}
                    </app-radio>
                </app-box>
                <app-box
                    :available="true"
                    label="機器の仕様の入力"
                    class="flex_column"
                    @click="guideTransition"
                    name="cs_dc_input">
                    <app-radio
                        v-for="(name, value) in master.cs_dc_input"
                        v-model="cs_dc_input"
                        :value="value"
                        unit=""
                        :key="'cs_dc_input' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    :available="true"
                    v-if=" cs_dc_input == '2' || cs_dc_input == '3'"
                    label="定格冷房能力試験"
                    class="flex_column dc_input">
                    <app-text
                        label="能力"
                        unit="W"
                        v-model="cs_dc_rated_capacity"
                        class=""
                        subscript="(整数)"
                        step="1"
                        @click="guideTransition"
                        name="cs_dc_rated_capacity"
                    />
                    <app-text
                        label="消費電力"
                        unit="W"
                        v-model="cs_dc_rated_power"
                        class=""
                        subscript="(整数)"
                        step="1"
                        @click="guideTransition"
                        name="cs_dc_rated_power"
                    />
                    <app-text
                        label="風量"
                        unit="m3/h"
                        v-model="cs_dc_rated_air_flow"
                        class=""
                        subscript="(小数点以下1桁)"
                        step="0.1"
                        @click="guideTransition"
                        name="cs_dc_rated_air_flow"
                    />
                    <app-text
                        label="室内側送風機の消費電力"
                        unit="W"
                        v-model="cs_dc_rated_fan_power"
                        class=""
                        subscript="(整数)"
                        step="1"
                        @click="guideTransition"
                        name="cs_dc_rated_fan_power"
                    />
                </app-box>
                <app-box
                    v-if="cs_dc_input == '3'"
                    :available="true"
                    label="中間冷房能力試験"
                    class="flex_column dc_input">
                    <app-text
                        label="能力"
                        unit="W"
                        v-model="cs_dc_middle_capacity"
                        class=""
                        subscript="(整数)"
                        step="1"
                        @click="guideTransition"
                        name="cs_dc_middle_capacity"
                    />
                    <app-text
                        label="消費電力"
                        unit="W"
                        v-model="cs_dc_middle_power"
                        class=""
                        subscript="(整数)"
                        step="1"
                        @click="guideTransition"
                        name="cs_dc_middle_power"
                    />
                    <app-text
                        label="風量"
                        unit="m3/h"
                        v-model="cs_dc_middle_air_flow"
                        class=""
                        subscript="(小数点以下1桁)"
                        step="0.1"
                        @click="guideTransition"
                        name="cs_dc_middle_air_flow"
                    />
                    <app-text
                        label="室内側送風機の消費電力"
                        unit="W"
                        v-model="cs_dc_middle_fan_power"
                        class=""
                        subscript="(整数)"
                        step="1"
                        @click="guideTransition"
                        name="cs_dc_middle_fan_power"
                    />
                </app-box>
                <app-box
                    :available="true"
                    label="設計風量の入力"
                    class="flex_column">
                    <app-radio
                        v-for="(name, value) in master.cs_dc_input_air_flow"
                        v-model="cs_dc_input_air_flow"
                        :value="value"
                        unit=""
                        :key="'cs_dc_input_air_flow' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    v-if="cs_dc_input_air_flow == '2'"
                    :available="true"
                    label="設計風量"
                    class="flex_column"
                    @click="guideTransition"
                    name="cs_dc_air_volume">
                    <app-text
                        label=""
                        unit="m3/h"
                        v-model="cs_dc_air_volume"
                        class=""
                        subscript="(小数点以下1桁)"
                        step="0.1"
                    />
                </app-box>
            </app-section>
        </div>
        <!-- 内容ここまで -->
    </div>
</div>
</template>

<script>
/**
 * 詳細版冷房情報入力画面
 * 
 * [算出プロパティ]
 * isSonotanokyoshitu ... その他の居室が存在するか
 * isHikyoshitsu ... 非居室が存在するか
 * 他は詳細版インタフェイス定義の同名項目に準ずる
 * 
 * [イベント処理]
 * インタフェイス定義済み項目の更新時 ... Storeの該当するキーのデータも更新される
 */
import help from "@/mixins/help"
import master from "@/mixins/master"
import { mapGetters, mapActions } from 'vuex'
import { mapComputedProperties } from '@/util'

export default {
    name:"PageManualCooling",
    computed: {
        ...mapGetters('data', {
            data:'getData',
        }),
        ...mapComputedProperties([
            'cs_houhou',
            'cs_ldk_type',
            'cs_ldk_type1_houhou',
            'cs_ldk_aircon_koukouritsu',
            'cs_ldk_aircon_dualcompressor',
            'cs_ldk_other_name',
            'bsc_kyoshitsu_kousei',
            'bsc_sonotakyoshitsu',
            'bsc_hikyoshitsu',
            'cs_nldk_type',
            'cs_nldk_type1_houhou',
            'cs_nldk_aircon_koukouritsu',
            'cs_nldk_aircon_dualcompressor',
            'cs_nldk_other_name',
            'cs_type',
            'cs_dc_duct_dannnetu',
            'cs_dc_vav',
            'cs_dc_general_ventilation',
            'cs_dc_input',
            'cs_dc_rated_capacity',
            'cs_dc_rated_power',
            'cs_dc_rated_air_flow',
            'cs_dc_rated_fan_power',
            'cs_dc_middle_capacity',
            'cs_dc_middle_power',
            'cs_dc_middle_air_flow',
            'cs_dc_middle_fan_power',
            'cs_dc_input_air_flow',
            'cs_dc_air_volume'
        ]),
        /**
         * @returns Boolean その他の居室が存在するか
         */
        isSonotanokyoshitu(){
            return (this.bsc_kyoshitsu_kousei == 1 || this.bsc_sonotakyoshitsu == 1)
        },
        /**
         * @returns Boolean 非居室が存在するか
         */
        isHikyoshitsu(){
            return (this.bsc_kyoshitsu_kousei == 1 || this.bsc_hikyoshitsu == 1)
        }
    },
    mixins:[help, master],
    methods:{
        ...mapActions('data', ['update']),
    }
}
</script>

<style scoped>

.dc_input >>> .grid_2 label{
    display: inline-block;
    width: 14em;
}
.uq_subbox_18em >>> .grid_2 .radio_sub_box{
    grid-template-columns: 18em 1fr;
    -ms-grid-columns: 18em 1fr;
}
</style>

